import classnames from 'classnames';
import React from 'react';

type Props = { messages?: string[]; className?: string };

export const ErrorMessages = ({ messages, className }: Props) => {
  // dangerouslySetInnerHTML is ugly but this way we can have html in messages...
  const content = messages?.map((messageKey, index) => (
    <div
      className="form-message-txt"
      key={`${index}_${messageKey}`}
      dangerouslySetInnerHTML={{ __html: messageKey }}
    />
  ));
  return <div className={classnames('form-message', className)}>{content}</div>;
};
